import { ApiError } from "pages/admin-app/shared/models/response/api-errors";

import { useQuery } from "@tanstack/react-query";
import { GetTerritoryManagerResponse } from "../models/response/get-territory-manager-response";
import { getTerritoryManager } from "../services/territory-manager-service";

interface Props {
  territoryManagerId: number | string;
}

export function useTerritoryManager({ territoryManagerId }: Props) {
  const { data, error, isLoading, isError, refetch } = useQuery<
    GetTerritoryManagerResponse,
    ApiError
  >({
    queryKey: ["territoryManager", territoryManagerId],
    queryFn: () => getTerritoryManager({ territoryManagerId }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
  };
}
